// Топ городов России с координатами центра
export const CITIES = [
  { id: 'moscow',          name: 'Москва',          lat: 55.7558, lng: 37.6173 },
  { id: 'spb',             name: 'Санкт-Петербург', lat: 59.9343, lng: 30.3351 },
  { id: 'novosibirsk',     name: 'Новосибирск',     lat: 54.9884, lng: 82.9319 },
  { id: 'ekaterinburg',    name: 'Екатеринбург',    lat: 56.8389, lng: 60.6057 },
  { id: 'kazan',           name: 'Казань',           lat: 55.8304, lng: 49.0661 },
  { id: 'chelyabinsk',     name: 'Челябинск',        lat: 55.1644, lng: 61.4368 },
  { id: 'omsk',            name: 'Омск',             lat: 54.9885, lng: 73.3242 },
  { id: 'samara',          name: 'Самара',           lat: 53.1959, lng: 50.1503 },
  { id: 'rostov',          name: 'Ростов-на-Дону',  lat: 47.2357, lng: 39.7015 },
  { id: 'ufa',             name: 'Уфа',              lat: 54.7388, lng: 55.9721 },
  { id: 'krasnoyarsk',     name: 'Красноярск',       lat: 56.0153, lng: 92.8932 },
  { id: 'perm',            name: 'Пермь',            lat: 58.0105, lng: 56.2502 },
  { id: 'voronezh',        name: 'Воронеж',          lat: 51.6683, lng: 39.1919 },
  { id: 'volgograd',       name: 'Волгоград',        lat: 48.7080, lng: 44.5133 },
  { id: 'krasnodar',       name: 'Краснодар',        lat: 45.0360, lng: 38.9760 },
  { id: 'saratov',         name: 'Саратов',          lat: 51.5336, lng: 46.0343 },
  { id: 'tyumen',          name: 'Тюмень',           lat: 57.1522, lng: 68.0000 },
  { id: 'tolyatti',        name: 'Тольятти',         lat: 53.5303, lng: 49.3461 },
  { id: 'izhevsk',         name: 'Ижевск',           lat: 56.8527, lng: 53.2114 },
  { id: 'barnaul',         name: 'Барнаул',          lat: 53.3606, lng: 83.7636 },
  { id: 'ulyanovsk',       name: 'Ульяновск',        lat: 54.3282, lng: 48.3866 },
  { id: 'irkutsk',         name: 'Иркутск',          lat: 52.2978, lng: 104.2964 },
  { id: 'khabarovsk',      name: 'Хабаровск',        lat: 48.4827, lng: 135.0840 },
  { id: 'yaroslavl',       name: 'Ярославль',        lat: 57.6261, lng: 39.8845 },
  { id: 'vladivostok',     name: 'Владивосток',      lat: 43.1155, lng: 131.8855 },
  { id: 'makhachkala',     name: 'Махачкала',        lat: 42.9849, lng: 47.5047 },
  { id: 'tomsk',           name: 'Томск',            lat: 56.4977, lng: 84.9744 },
  { id: 'orenburg',        name: 'Оренбург',         lat: 51.7727, lng: 55.0988 },
  { id: 'kemerovo',        name: 'Кемерово',         lat: 55.3348, lng: 86.0880 },
  { id: 'novokuznetsk',    name: 'Новокузнецк',      lat: 53.7596, lng: 87.1216 },
  { id: 'ryazan',          name: 'Рязань',           lat: 54.6269, lng: 39.6916 },
  { id: 'astrakhan',       name: 'Астрахань',        lat: 46.3479, lng: 48.0330 },
  { id: 'penza',           name: 'Пенза',            lat: 53.1959, lng: 45.0184 },
  { id: 'lipetsk',         name: 'Липецк',           lat: 52.6031, lng: 39.5708 },
  { id: 'tula',            name: 'Тула',             lat: 54.1961, lng: 37.6182 },
  { id: 'kirov',           name: 'Киров',            lat: 58.6035, lng: 49.6680 },
  { id: 'cheboksary',      name: 'Чебоксары',        lat: 56.1439, lng: 47.2489 },
  { id: 'kaliningrad',     name: 'Калининград',      lat: 54.7104, lng: 20.4522 },
  { id: 'bryansk',         name: 'Брянск',           lat: 53.2434, lng: 34.3634 },
  { id: 'kursk',           name: 'Курск',            lat: 51.7304, lng: 36.1928 },
  { id: 'ivanovo',         name: 'Иваново',          lat: 57.0005, lng: 40.9739 },
  { id: 'magnitogorsk',    name: 'Магнитогорск',     lat: 53.4072, lng: 59.0614 },
  { id: 'tver',            name: 'Тверь',            lat: 56.8587, lng: 35.9176 },
  { id: 'stavropol',       name: 'Ставрополь',       lat: 45.0448, lng: 41.9690 },
  { id: 'nizhny_novgorod', name: 'Нижний Новгород',  lat: 56.2965, lng: 43.9361 },
];

// Расстояние между двумя точками в км (формула гаверсинуса)
export const distanceKm = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// Все города в радиусе 100км от данного города
export const nearbyCityIds = (cityId, radiusKm = 100) => {
  const origin = CITIES.find(c => c.id === cityId);
  if (!origin) return [cityId];
  return CITIES
    .filter(c => distanceKm(origin.lat, origin.lng, c.lat, c.lng) <= radiusKm)
    .map(c => c.id);
};
